interface ColumnHeader {
  key: string;
  text: string;
  align: 'left' | 'right';
}

export const HEADERS: ColumnHeader[] = [
  { key: 'initialInvestmentDate', text: 'Initial Investment Date', align: 'left' },
  { key: 'committedCapital', text: 'Committed capital', align: 'right' },
  { key: 'contributedCapital', text: 'Contributed capital', align: 'right' },
  { key: 'totalCashDistribution', text: 'Total Cash Distribution', align: 'right' },
  { key: 'value', text: 'Value', align: 'right' },
  { key: 'valuationDate', text: 'Valuation date', align: 'left' },
  { key: 'multiple', text: 'Multiple', align: 'right' },
  { key: 'return', text: 'Return', align: 'right' },
];

export enum SortingDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type Sorting = Record<string, SortingDirection>;

export const sortValues = (a: string | number, b: string | number, sorting: Sorting) => {
  const sortingKey = Object.keys(sorting)[0];
  const dateKeys = ['initialInvestmentDate', 'valuationDate'];
  const aValue = dateKeys.includes(sortingKey) ? (a ? new Date(a) : null) : a;
  const bValue = dateKeys.includes(sortingKey) ? (b ? new Date(b) : null) : b;
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  return sorting[sortingKey] === SortingDirection.Asc ? aValue - bValue : bValue - aValue;
};
